import React, {useEffect, useRef, useState} from "react";
import IbatApi from "../utils/IbatApi";
import CustomImage from "../components/util/CustomImage";
import Caroussel from "../components/util/Caroussel";
import "./layer.css"
import {getIcon} from "../helpers/assetManager";


export default function Layer({points, background}){
    const [state,setState]=useState({})
    const [selectedPoint,setSelectedPoint]=useState(false)
    const canvasRef=useRef();
    const api=new IbatApi()
    const [img, setImg]=useState()


    const scale = 1


    useEffect(() => {
        api.getFile(background)
            .then(img => {
                setImg(img.url)
                handleBackground(img.url)
            })
    }, [background])

    function handleBackground(image){
        let ctx = canvasRef.current.getContext('2d');
        let bkGround = new Image();
        bkGround.src = image ?? img;
        bkGround.onload = (e)=>{
            setState({width:bkGround.width,height:bkGround.height})
            ctx.drawImage(bkGround,0,0, bkGround.width, bkGround.height);
            points?.forEach(p=>draw(ctx, p,bkGround))
        }
    }

    function draw(ctx, p,bkg) {
        const icon=new Image()
        icon.src = dataIdToImg(p.dataId)
        icon.onload=()=> {
            ctx.fillStyle = p.name === "Repair" ? '#00f' : "#ff0000";
            ctx.beginPath()
            ctx.arc(Math.abs(1 - p.y) * bkg.width*scale, Math.abs(p.x) * bkg.height*scale, 5, 0, 2 * Math.PI)
            ctx.fill()
            ctx.drawImage(icon, Math.abs(1 - p.y) * bkg.width*scale - icon.width / 2, Math.abs(p.x) * bkg.height*scale - icon.height / 2)
        }
    }


    function dataIdToImg(id){
        return getIcon(id)
    }
    function getSelectedPicturePath(p) {
        if (p?.picture?.filePath) return p.picture.filePath;
        if (p?.picture?.path) return p.picture.path;
        if (typeof p?.picture === 'string') return p.picture;
        if (p?.picturePath) return p.picturePath;
        if (p?.pictureFilePath) return p.pictureFilePath;
        if (Array.isArray(p?.pictureList) && p.pictureList.length > 0) {
            const visible = p.pictureList.filter(pic => pic.visible !== false);
            const list = (visible.length ? visible : p.pictureList)
                .slice()
                .sort((a, b) => (b.date || 0) - (a.date || 0));
            const candidate = list[0];
            return candidate?.filePath || candidate?.path || null;
        }
        return null;
    }
    function handleFamilyPicture(listPictures) {
        let mothers = listPictures?.filter(pic => !pic.motherId)
        let families = []
        for (let mother of mothers) {
            let fam = [...listPictures.filter(childPic => childPic.motherId === mother.id)]
            fam.push(mother)
            families.push(fam)
        }
        return families.filter(fam => fam.length > 0)
    }
    function handlePicture(selectedPoint) {
        console.log(selectedPoint)
        setSelectedPoint(selectedPoint)
    }

    function getPoints(x,y,area,width,height){
        points.map(p=>({...p,x:Math.abs(1-p.y)*width,y:(p.x)*height,picture:p.picture}))
            .filter(p=>Math.abs(p.x-x)<= area && Math.abs(p.y-y)<=area)
            .forEach(p=>handlePicture(p))
    }

    function handlePoint(e) {
        const rect=canvasRef.current.getBoundingClientRect()
        const width=rect.right-rect.left
        const height=rect.bottom-rect.top
        const x = e.clientX - rect.left
        const y = e.clientY - rect.top
        getPoints(x,y,5,width,height)
    }

    return (

        <div className={`layer`}>
            <div className={`flex-row w100`}>
                <div>
                    <div className={"flex-column"}>
                        <canvas id={"layer"} width={state.width} height={state.height} onClick={handlePoint}
                                ref={canvasRef}/>
                    </div>
                </div>
                {
                    selectedPoint &&
                    <div className={"handle-point flex-column"}>
                        <h1>{selectedPoint?.dataName ?? selectedPoint?.name !== "Repair" ? selectedPoint?.name : ""}</h1>
                        { (() => {
                            const picturePath = getSelectedPicturePath(selectedPoint);
                            if (Array.isArray(selectedPoint?.pictureList) && selectedPoint.pictureList.length > 0) {
                                const list = handleFamilyPicture(selectedPoint.pictureList)
                                    .sort((pF1, pF2) => pF1[0].date - pF2[0].date)
                                    .map((pF, idx) => ({ index: idx, family: pF }));
                                const visible = selectedPoint.pictureList.filter(pic => pic.visible !== false);
                                const orderedAsc = (visible.length ? visible : selectedPoint.pictureList)
                                    .slice()
                                    .sort((a, b) => (a.date || 0) - (b.date || 0));
                                const firstFile = orderedAsc[0]?.filePath;
                                return (
                                    <Caroussel
                                        list={list}
                                        firstFile={firstFile}
                                        listOperation={[]}
                                    />
                                );
                            }
                            return picturePath ? (
                                <CustomImage width={600} className={"layer-img"} name={picturePath} />
                            ) : null;
                        })() }
                        {
                            (selectedPoint?.reportComment || selectedPoint?.reportRecommendation) &&
                            <div className={"secondary-section flex-column"}>
                                { selectedPoint?.reportComment &&
                                    <div className={"flex-row"}>
                                        <h2>Commentaire : </h2>
                                        <p>{selectedPoint.reportComment}</p>
                                    </div>
                                }
                                { selectedPoint?.reportRecommendation &&
                                    <div className={"flex-row"}>
                                        <h2>Recommandation : </h2>
                                        <p>{selectedPoint.reportRecommendation}</p>
                                    </div>
                                }
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
    )

}